import { Component } from '@mycolorway/tao';
import { MDCTabBar } from '@material/tab-bar';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-tabs', {
  mixins: [eventListenerMixin],

  properties: {
    activeIndex: {
      type: Number,
      default: 0,
      observer(value) {
        this.mdcTabBar.activateTab(value);
      },
    },
  },

  connected() {
    this.tabs = this.querySelectorAll('.mdc-tab');

    this.mdcTabBar = new MDCTabBar(this.querySelector('.mdc-tab-bar'));
    this.mdcTabBar.focusOnActivate = false;
    this.mdcTabBar.useAutomaticActivation = false;

    this.mdcTabBar.activateTab(this.activeIndex);

    this.listenTo(this.mdcTabBar, {
      'MDCTabBar:activated': (event) => {
        this.namespacedTrigger('activated', {
          detail: {
            tab: this.tabs[event.detail.index],
            index: event.detail.index,
          },
        });
      },
    });
  },

  disconnected() {
    this.stopListening();
    if (this.mdcTabBar) this.mdcTabBar.destroy();
  },
});
